import { ApiResponse, PaginatedData } from './api';
import { InvoiceDocument } from './document';
import { Company, User } from './user';

export enum InvoicingListTab {
  GENERATED = 'generated',
  RECURRENT = 'recurrent'
}

export enum RecurrentInvoiceStatus {
  ACTIVE = 'active',
  PAUSED = 'paused'
}

export enum RecurrentInvoiceFrequency {
  WEEKLY = 'weekly',
  BIWEEKLY = 'biweekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly'
}

export interface RecurrentInvoice {
  _id: string;
  customer_name: string;
  customer_vat_number: string;
  subject: string;
  frequency: RecurrentInvoiceFrequency;
  next_send_label: string;
  vat_amount: number;
  vat_rate: number;
  total: number;
  currency: string;
  status: RecurrentInvoiceStatus;
}

export enum RecurrentInvoiceNotificationMethod {
  EMAIL = 'email'
}

export interface RecurrentInvoiceNotificationSettings {
  enabled: boolean;
  method: RecurrentInvoiceNotificationMethod;
}

export interface RecurrentInvoiceRecord {
  _id: string;
  company: Company;
  active: boolean;
  frequency: RecurrentInvoiceFrequency;
  next_invoice_date: string;
  last_invoice_date?: string;
  created: string;
  invoice_reference: InvoiceDocument;
  created_by: User;
  customer_notification: RecurrentInvoiceNotificationSettings;
  contact_notification: RecurrentInvoiceNotificationSettings;
}

export interface UpdateRecurrentInvoiceRequest {
  id: string;
  frequency?: RecurrentInvoiceFrequency;
  next_invoice_date?: string;
  invoice_reference?: string;
  customer_notification?: Partial<RecurrentInvoiceNotificationSettings>;
  contact_notification?: Partial<RecurrentInvoiceNotificationSettings>;
}

export interface UpdateRecurrentInvoiceStatusRequest {
  id: string;
  active: boolean;
}

export type CreateOrUpdateRecurrentInvoiceResponse = ApiResponse<{
  recurrent_invoice: RecurrentInvoiceRecord;
}>;

export type GetRecurrentInvoiceResponse = ApiResponse<{
  recurrent_invoice: RecurrentInvoiceRecord;
}>;

export type DeleteRecurrentInvoiceResponse = ApiResponse<{
  deleted: boolean;
}>;

export type GetPaginatedRecurrentInvoicesResponse = ApiResponse<{
  data: PaginatedData & {
    recurrent_invoices: RecurrentInvoiceRecord[];
  };
}>;
